// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1ak04","header":"Messages_header__2LO8e"};